
const digest = '9135127e4b7b44b693f5fb35bc8fd7955722013f148db4a372749bca20358fad';
const classes = {"title":"_title_11k5a_1","plus":"_plus_11k5a_7"};
const css = `._title_11k5a_1 {
  font-size: 18px;
  font-weight: 500;
  color: #000;
}

._plus_11k5a_7 {
  margin: 20px 8px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  